/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import React from "react";
import {
  GridRowModes,
  GridToolbarContainer,
  GridActionsCellItem,
  GridRowEditStopReasons,
} from "@mui/x-data-grid";
// Material Dashboard 2 React example components
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import Footer from "../../examples/Footer";
import { baseURL, baseUrl } from "utils/api";
import * as XLSX from "xlsx";

// Data

import reportsLineChartData from "../../layouts/dashboard/data/reportsLineChartData";
import shoes from "./Image/shoes.jpg";

// Dashboard components

import Box from "@mui/material/Box";
import { useState, useEffect, useMemo } from "react";
import { DataGrid } from "@mui/x-data-grid";
import Tooltip from "@mui/material/Tooltip";
import EditIcon from "@mui/icons-material/Edit";
import useSWR from "swr";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Close";
import axios from "axios";
import LoaderComponent from "components/Loader";
import IconButton from "@mui/material/IconButton";
import { MdOutlinePreview } from "react-icons/md";
import { FaEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import Swal from "sweetalert2";
import Rating from "@mui/material/Rating";
import StarIcon from '@mui/icons-material/Star';


function ShopList() {
  const fetchData = async (url) => {
    try {
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };

  const navigate = useNavigate();
  //----------------------GET------------------------------------//
  const [Userdata, setUserdata] = useState([]);
  const [data, setData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [page, setPage] = useState({ page: 1, pageSize: 10 });
  const [loading, setLoading] = useState(true);
  const [totalPages, setTotalPages] = useState("");
  const fetchDataForMultiplePages = async () => {
    try {
      let allUserData = [];
      let totalItems = 0;
      console.log(page, "PAGE");
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/store/getStore?page=${page.page}&limit=${page.pageSize}`
      );
      console.log(page, "PAGE");
      const { stores } = response.data;
      setUserdata(stores);
      allUserData = [...allUserData, ...stores];
      totalItems = response.data.totalStores;
      setTotalRows(totalItems);
      setTotalPages(totalPages);

      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDataForMultiplePages();
  }, [page]);

  const [file, setFile] = useState("");

  const [formLoading, setFormLoading] = useState(false);

  const [rowData, setRowData] = useState("");
  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };
  // ------------------CHOSE EXCEL---------------------------------//
  const [uploadingFile, setUploadingFile] = useState(0);

  const handleSubmitFile = async () => {
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);
    setUploadingFile(1);

    const options = {
      onUploadProgress: (progressEvent) => {
        const { loaded, total } = progressEvent;

        let percent = Math.floor((loaded * 100) / total);
        console.log(`${loaded}kb of ${total}kb | ${percent}%`);

        if (percent < 100) {
          setUploadingFile(percent);
        }
      },
    };
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/store/uploadStore/`,
        formData,
        options
      );

      if (response.ok) {
        const data = await response.json();
        setRowData(data);
        setUploadingFile(100);
        setTimeout(() => {
          setUploadingFile(0);
        }, 1000);
      } else {
        console.error("Failed to upload file");
        setUploadingFile(0);
      }
    } catch (error) {
      console.error("Error uploading file:", error);
      setUploadingFile(0);
    }
  };

  // const [excelData, setExcelData] = useState([]);

  // const handleFileUpload = (e) => {
  //   const file = e.target.files[0];
  //   const reader = new FileReader();

  //   reader.onload = (evt) => {
  //     const data = evt.target.result;
  //     const workbook = XLSX.read(data, { type: 'binary' });
  //     const sheetName = workbook.SheetNames[0];
  //     const worksheet = workbook.Sheets[sheetName];
  //     const excelData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
  //     setExcelData(excelData);
  //   };

  //   reader.readAsBinaryString(file);
  // };

  const rows = data?.stores ? data?.stores : [];
  const [allIds, setAllIds] = useState([]);
  const onRowsSelectionHandler = (ids) => {
    console.log(ids);
    setAllIds(ids);
    // const selectedRowsData = ids.map((id) => rows.find((row) => row.id === id));
    // const foundIds = selectedRowsData.map((d) => d.id);
    // setAllIds(foundIds);
  };
  console.log(allIds);
  const handleDeleteSelectedRows = async () => {
    let result = confirm("Are you sure you want to delete?");
    if (!result) {
      return;
    }
    try {
      setFormLoading(true);
      const res = await axios.post(`${process.env.REACT_APP_BASE_URL}/store/deleteMultiStore/`, {
        ids: allIds,
      });
      fetchDataForMultiplePages();
      setShowSnack(true);
      setFormLoading(false);
    } catch (error) {
      setFormLoading(false);
    }
  };

  // const handleDeleteStore = async (id) => {
  //   console.log(id);
  //   try {
  //     const res = await axios.get(`${baseURL}/admin/store/delete/${id}`);
  //     if (res.status === 200) {
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  const [rowModesModel, setRowModesModel] = useState({});
  const [updatedNewRow, setUpdatedRow] = useState(null);

  const processRowUpdate = async (newRow) => {
    const updatedRow = { ...newRow, isNew: false };
    setUpdatedRow(updatedRow);
    console.log(newRow);
    await handleUpdateCategory(newRow.id, newRow);
    setRows(rows.map((row) => (row.id === newRow.id ? updatedRow : row)));

    return updatedNewRow;
  };
  const handleSaveClick = async (id, categoryData) => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });
  };

  const handleRowEditStop = (params, event) => {
    if (params.reason === GridRowEditStopReasons.rowFocusOut) {
      event.defaultMuiPrevented = true;
    }
  };
  const handleCancelClick = (id) => () => {
    setRowModesModel({
      ...rowModesModel,
      [id]: { mode: GridRowModes.View, ignoreModifications: true },
    });
  };

  const handleEditClick = (id) => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
  };

  const handleRowModesModelChange = (newRowModesModel) => {
    setRowModesModel(newRowModesModel);
  };

  // async function handleUpdateCategory(id, obj) {
  //   try {
  //     console.log(id);
  //     setFormLoading(true);

  //     const res = await axios.post(
  //       `${baseURL}/admin/update/store/${id}`,
  //       {
  //         ...obj,
  //       },
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     );

  //     if (res.status === 200) {
  //       setFormLoading(false);
  //     }
  //     setFormLoading(false);
  //   } catch (error) {
  //     setFormLoading(false);
  //     console.log(error);
  //   }
  // }
  // --------------------------------DELETE----------------------------------------------//
  const deleteBodyDataImages = async (id) => {
    console.log(id, "AAAAAAAAAAAAAAAAAAAA");
    try {
      const isConfirmed = window.confirm("Are you sure you want to delete this item?");
      if (!isConfirmed) return;

      const response = await fetch(`${process.env.REACT_APP_BASE_URL}/store/deleteStore/${id}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
        },
      });
      fetchDataForMultiplePages();
      if (!response.ok) {
        throw new Error("Failed to delete data");
      }
      const data = await response.json();
      console.log("Body data images deleted successfully:", data);
    } catch (error) {
      console.error("Error deleting body data images:", error.message);
    }
  };

  const handleDeleteButtonClick = (id) => {
    deleteBodyDataImages(id);
  };
  // -------------------------------------------------------//

 
  const rowsdata = useMemo(
    () =>
      Userdata &&
      Userdata.map((stores, index) => ({
        ...stores,
        id: stores.id,
      }))
  );
  const columns = [
    // {
    //   field: "id",
    //   headerName: "Id",
    //   width: 150,
    // },
    
    {
      field: "vendorId",
      headerName: "Vendor Id",
      width: 150,
    },
    {
      field: "companyName",
      headerName: "Company Name",
      width: 150,
      editable: true,
    },

    {
      field: "storeImage",
      headerName: "Image",
      width: 150,
      renderCell: (params) => (
        <img src={params.value} alt="Store Image" style={{ width: "64px", height: "40px" }} />
      ),
    },

   

    {
      field: "sid",
      headerName: "SID value",
      width: 150,
    },
    {
      field: "address",
      headerName: "Send Goods address",
      width: 150,
      editable: true,
    },
    {
      field: "products",
      headerName: "No. of Products",
      width: 150,
      editable: true,
    },

    
    {
      field: "rating",
      headerName: "No. of Rating",
      width: 150,
      editable: true,
      renderCell: (param) => {
        const [value, setValue] = React.useState(4.5);
        const [hover, setHover] = React.useState(-1);
        const labels = {
          0.5: "Useless",
          1: "Poor",
          1.5: "Poor+",
          2: "Average",
          2.5: "Average+",
          3: "Good",
          3.5: "Good+",
          4: "Excellent",
          4.5: "Excellent+",
          5: "Outstanding",
        };
        const getLabelText = (value) => {
          return labels[value];
        };
    
        return (
          <>
            <div className="flex flex-col gap-2">
              <Rating
                name="hover-feedback"
                value={value}
                precision={0.5}
                getLabelText={getLabelText}
                onChange={(event, newValue) => {
                  setValue(newValue);
                }}
                onChangeActive={(event, newHover) => {
                  setHover(newHover);
                }}
                emptyIcon={<StarIcon style={{ opacity: 0.55 }} fontSize="inherit" />}
              />
              {value !== null && (
                <Box sx={{ ml: 2 }}>{labels[hover !== -1 ? hover : value]}</Box>
              )}
            </div>
          </>
        );
      },
    },
    
  

    {
      field: "subscribers",
      headerName: "No. of Subscribers",
      width: 150,
      editable: true,
    },

    {
      field: "action",
      headerName: "Action",
      description: "This column has a value getter and is not sortable.",
      sortable: false,
      width: 180,
      renderCell: (param) => {
        return (
          <>
            <div style={{ display: "flex", gap: "6px" }}>
              <Tooltip onClick={() => navigate("/view_details", { state: param.row })} title="view">
                <IconButton>
                  <MdOutlinePreview style={{ cursor: "pointer" }} />
                </IconButton>
              </Tooltip>
              <Tooltip
                onClick={() =>
                  navigate(
                    `/edit_shop/${param.row.id}`,
                    console.log({ state: { productId: param.row.id } }),
                    "AAAAAAAA"
                  )
                }
                title="Edit"
              >
                <IconButton>
                  <FaEdit className="text-blue-400" style={{ cursor: "pointer" }} />
                </IconButton>
              </Tooltip>
              <Tooltip title="Delete">
                <IconButton onClick={() => handleDeleteButtonClick(param.row.id)}>
                  <MdDelete style={{ cursor: "pointer" }} />
                </IconButton>
              </Tooltip>
            </div>
          </>
        );
      },
      valueGetter: (params) => `${params.row.Name || ""} ${params.row.lastName || ""}`,
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Quick Edit",
      width: 100,
      cellClassName: "actions",
      getActions: (params) => {
        const isInEditMode = rowModesModel[params.id]?.mode === GridRowModes.Edit;

        if (isInEditMode) {
          return [
            <GridActionsCellItem
              icon={<SaveIcon />}
              label="Save"
              sx={{
                color: "green",
              }}
              onClick={() => {
                const rowWithoutImage = Object.entries(params.row).reduce((acc, [key, value]) => {
                  if (key !== "image") {
                    acc[key] = value;
                  }
                  return acc;
                }, {});
                console.log(rowWithoutImage);
                handleSaveClick(params.id, rowWithoutImage);
                // window.location.reload();
              }}
            />,
            <GridActionsCellItem
              icon={<CancelIcon />}
              label="Cancel"
              className="textPrimary"
              onClick={handleCancelClick(params.id)}
              color="inherit"
            />,
          ];
        }
        return [
          <GridActionsCellItem
            icon={<EditIcon className="text-blue-400" />}
            label="Edit"
            className="textPrimary"
            onClick={handleEditClick(params.id)}
            color="inherit"
          />,
        ];
      },
      valueGetter: (params) => `${params.row.Name || ""} ${params.row.lastName || ""}`,
    },
  ];

  return (
    <DashboardLayout>
      {!data && <LoaderComponent open={true} />}
      {formLoading && <LoaderComponent open={true} />}

      <DashboardNavbar />
      <MDBox py={3}>
        <form style={{ display: "flex", gap: "20px", alignItems: "center", marginLeft:"74%" }}>
          <div className="flex">
            <div className="flex flex-col gap-4">
              <label htmlFor="fileSelect">
                <span className="bg-green-700 rounded-md w-[10vw] cursor-pointer p-2 border-none outline-none ml-[1vw] text-white text-sm">
                  Choose Excel file
                </span>
              </label>
              <input
                style={{ display: "none" }}
                type="file"
                id="fileSelect"
                onChange={handleFileChange}
                accept=".xlsx, .xls, .csv"
              />
              <span className="text-sm">{file?.name}</span>
              {file && (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSubmitFile}
                  sx={{ color: "white !important" }}
                >
                  Submit
                </Button>
              )}

              {console.log(uploadingFile, "uploadingFile")}
            </div>

            <div className="flex">
              <label>
                <span
                  onClick={() => navigate("/add_new_shop")}
                  type="button"
                  className="bg-blue-700 h-[5vh] rounded-md text-sm w-[10vw] cursor-pointer p-2 border-none outline-none ml-[1vw] text-white"
                >
                  Upload Manually
                </span>
              </label>
            </div>
          </div>
          {/* <div style={{ marginLeft: "10vw" }}>
            <Button type={"submit"} background={"green"} title={"Submit"} />
          </div> */}
        </form>
        {allIds.length > 0 && (
          <label>
            {" "}
            <span
              onClick={handleDeleteSelectedRows}
              type="button"
              className="bg-red-700 h-[5vh] rounded-md text-sm w-[10vw] cursor-pointer p-2 border-none outline-none ml-[1vw] text-white"
            >
              Delete Selected
            </span>
          </label>
        )}
        <Box sx={{ height: 550, width: "100%", background: "white",  }}>
          <DataGrid
            rows={rowsdata}
            rowCount={totalRows}
            columns={columns}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 10,
                  page: 1,
                },
              },
            }}
            rowModesModel={rowModesModel}
            page={page}
            pagination
            paginationMode="server"
            onRowModesModelChange={handleRowModesModelChange}
            onRowEditStop={handleRowEditStop}
            processRowUpdate={processRowUpdate}
            pageSizeOptions={[5, 10, 25, 100]}
            checkboxSelection
            experimentalFeatures={{ newEditingApi: true }}
            onRowSelectionModelChange={(_ids) => onRowsSelectionHandler(_ids)}
            onPaginationModelChange={(newPage) => setPage(newPage)}
            disableRowSelectionOnClick
          />
        </Box>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default ShopList;
